import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';

import { tableCellEnumFactory } from 'components/table-cell/enum-cell';
import { TableColumn } from 'components/table/table-types';

import { useOriginatorClasses } from './register-api';
import { Originator } from 'types';

export function TableCellText({ allData }: { allData: Originator }) {
  return (
    <div>
      <Typography component="div" variant="body2">
        {allData.preferredName?.label}
      </Typography>

      <div style={{ fontSize: '12px', lineHeight: '12px' }}>
        {allData.description}
      </div>
    </div>
  );
}

export const registerColumns: TableColumn[] = [
  {
    id: 'preferredName.label',
    label: 'Rejstříkové heslo',
    disableSort: true,
    CellComponent: TableCellText,
  },
  {
    id: 'originatorClass',
    label: 'Třída',
    width: 200,
    disableSort: true,
    CellComponent: tableCellEnumFactory(useOriginatorClasses),
  },
];
